<template>
    <button @click.prevent="$emit('toggleView', 'cart')" class="c-overlay__notebook__tools__link">
        <svg aria-hidden="true" focusable="false" class="o-ico c-overlay__notebook__tools__link__icon">
            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#arrow-left"></use>
        </svg>
        Retour
    </button>
    <div class="o-spacer-sm"></div>
    <div class="o-flex -flex-direction-column -flex-middle -flex-grow-1 -flex-overflow-auto -flex-width-100p">
        <div class="o-form -form-dark">
            <div class="o-flex -flex-direction-column">
                <div class="o-form__group">
                    <label for="email" class="o-label sr-only">
                        Courriel
                    </label>
                    <input class="o-input" type="email" id="email" v-model="username" placeholder="Courriel" required>
                </div>
                <div class="o-form__group">
                    <label for="pass" class="o-label sr-only">
                        Mot de passe
                    </label>
                    <input class="o-input" type="password" id="pass" v-model="password" placeholder="Mot de passe" required>
                </div>
                <div v-if="error" class="o-alert -alert-error">
                    {{ error }}
                </div>
                <div class="o-flex -flex-space-between -flex-middle">
                    <button class="c-overlay__notebook__button__register" @click.prevent="$emit('toggleView', 'register')">S'inscrire</button>
                    <button @click.prevent="login()" class="c-overlay__notebook__button__login">
                        Connexion
                    </button>
                </div>
            </div>
            <div class="o-spacer"></div>
            <div class="o-flex -flex-center">
                <button class="c-overlay__notebook__button__password" @click.prevent="$emit('toggleView', 'forgot')">
                    Mot de passe oublié
                </button>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'CarnetLogin',
    data() {
        return {
            username: '',
            password: '',
            error: ''
            //
        }
    },
    mounted() {
    },
    methods: {
        login() {
            fetch(WPURLS.ajax_url+'?action=carnet_ajaxlogin',
                {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-WP-Nonce': WPURLS.nonce,
                    },
                    body: JSON.stringify({
                        username: this.username,
                        password: this.password
                    })
                })
                .then(response => response.json())
                .then(data => {
                    if (data.loggedin) {
                        this.$emit('toggleView', 'cart');
                        this.emitter.emit('getCart', 'cart');
                    } else {
                        this.error = data.message;
                    }
                });
        },
    }
}
</script>